const dataItem = {
    date: '',   // 日期
    singlePrice: '',    // 单价
    amount: '',    // 数量
    hasPay: '',  // 是否支付
}
const outItem = {
    name: '',   // 姓名
    address: '',    // 地址
    phone: '',  // 电话
    list: []
}

export function getNewItem() {
    const item = JSON.parse(JSON.stringify(dataItem));
    item.date = getNewDate();
    return item;
}
export function getStorage() {
    return new Promise((res, rej) => {
        axios('/get').then(data => {
            if(data) {
                console.log('获取到的数据：', JSON.parse(data));
                res(JSON.parse(data));
            } else {
                res([]);
            }
        })
    })
    // const data = window.localStorage.getItem('data');
    // return data ? JSON.parse(data) : undefined;
}
export function setStorage(data) {
    return axios('/set', JSON.stringify(data));
    // window.localStorage.setItem('data', JSON.stringify(data));
}

export function upgradeItem(item) {
    return new Promise((resolve, rej) => {
        getStorage().then(res => {
            const data = res;
            const index = data.findIndex(ware => ware.id == item.id);
            index > -1 && (data[index] = item);
            setStorage(data).then(() => {
                resolve('success');
            });
        });
    })
}

export function addRootItem(item) {
    return new Promise((resolve, rej) => {
        !item.id && (item.id = new Date().getTime());
        getStorage().then(res => {
            const data = res;
            if(!data) { 
                setStorage([item]).then(() => {
                    resolve('success');
                });
            } else {
                data.push(item);
                setStorage(data).then(() => {
                    resolve('success');
                });
            }
        });
    })
}

function getNewDate() {
    const date = new Date();
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function axios(url, data) {
    return fetch('http://localhost:8081'+url, {
        body: data,
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
    }).then(res => res.json());
}